export const SET_CLAIMSTATUS_ERROR =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_ERROR';
export type SET_CLAIMSTATUS_ERROR = typeof SET_CLAIMSTATUS_ERROR;

export const SET_CLAIMSTATUS_SUCCESS =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_SUCCESS';
export type SET_CLAIMSTATUS_SUCCESS = typeof SET_CLAIMSTATUS_SUCCESS;

export const SET_CLAIMSTATUS_DATA =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_DATA';
export type SET_CLAIMSTATUS_DATA = typeof SET_CLAIMSTATUS_DATA;

export const SET_CLAIMSTATUS_DATE_RANGE_FILTER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_DATE_RANGE_FILTER';
export type SET_CLAIMSTATUS_DATE_RANGE_FILTER = typeof SET_CLAIMSTATUS_DATE_RANGE_FILTER;

export const SET_CLAIMSTATUS_SORT_FILTER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_SORT_FILTER';
export type SET_CLAIMSTATUS_SORT_FILTER = typeof SET_CLAIMSTATUS_SORT_FILTER;

export const SET_CLAIMSTATUS_STATUS_FILTER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_STATUS_FILTER';
export type SET_CLAIMSTATUS_STATUS_FILTER = typeof SET_CLAIMSTATUS_STATUS_FILTER;

export const SET_CLAIMSTATUS_ORDER_STATUS_FILTER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_ORDER_STATUS_FILTER';
export type SET_CLAIMSTATUS_ORDER_STATUS_FILTER = typeof SET_CLAIMSTATUS_ORDER_STATUS_FILTER;

export const SET_CLAIMSTATUS_INVOICE_FILTER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_INVOICE_FILTER';
export type SET_CLAIMSTATUS_SEARCH_FILTER = typeof SET_CLAIMSTATUS_INVOICE_FILTER;

export const SET_CLAIMSTATUS_ORDER_FILTER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_ORDER_FILTER';
export type SET_CLAIMSTATUS_ORDER_FILTER = typeof SET_CLAIMSTATUS_ORDER_FILTER;

export const SET_CLAIMSTATUS_PO_FILTER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_PO_FILTER';
export type SET_CLAIMSTATUS_PO_FILTER = typeof SET_CLAIMSTATUS_PO_FILTER;

export const SET_CLAIMSTATUS_PAGE_NUMBER =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_PAGE_NUMBER';
export type SET_CLAIMSTATUS_PAGE_NUMBER = typeof SET_CLAIMSTATUS_PAGE_NUMBER;

export const SET_CLAIMSTATUS_PAGE_SIZE =
  'rpb2b-react/claimstatus/SET_CLAIMSTATUS_PAGE_SIZE';
export type SET_CLAIMSTATUS_PAGE_SIZE = typeof SET_CLAIMSTATUS_PAGE_SIZE;

export default {
  SET_CLAIMSTATUS_ERROR,
  SET_CLAIMSTATUS_SUCCESS,
  SET_CLAIMSTATUS_DATA,
  SET_CLAIMSTATUS_DATE_RANGE_FILTER,
  SET_CLAIMSTATUS_SORT_FILTER,
  SET_CLAIMSTATUS_STATUS_FILTER,
  SET_CLAIMSTATUS_ORDER_STATUS_FILTER,
  SET_CLAIMSTATUS_INVOICE_FILTER,
  SET_CLAIMSTATUS_ORDER_FILTER,
  SET_CLAIMSTATUS_PO_FILTER,
  SET_CLAIMSTATUS_PAGE_NUMBER,
  SET_CLAIMSTATUS_PAGE_SIZE
};
